import React from "react";
import styled from "styled-components";
import { Box } from "../common";

import { StyledText } from "../common/basic";
import { PadlockIcon } from "../svgs";

const VendorCard = ({
  backgroundImage,
  tag,
  title,
  description,
  onClick,
  lock,
}) => {
  return (
    <Wrapper onClick={() => onClick()}>
      {lock && (
        <LockCover>
          <CircularIconHolder>
            <PadlockIcon width={40} />
          </CircularIconHolder>
        </LockCover>
      )}
      <Image src={backgroundImage} />
      <Gradient>
        <CardDetails>
          <Body>
            <Box
              style={{
                backgroundColor: "transparent",
                margin: 0,
                display: "flex",
              }}
            >
              <Box style={{ backgroundColor: "#FFCD00" }}>
                <StyledText
                  size={8}
                  style={{ margin: 0, paddingLeft: 3, paddingRight: 3 }}
                >
                  {tag}
                </StyledText>
              </Box>
            </Box>
            <StyledText
              style={{ marginBlockEnd: 0, margin: 0 }}
              size={15}
              color={"white"}
            >
              {title}
            </StyledText>
            <StyledText style={{ marginTop: 0 }} size={8} color={"white"}>
              {description}
            </StyledText>
          </Body>
        </CardDetails>
      </Gradient>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 147px;
  height: 147px;
  border-radius: 20px;
  margin: 15px;
  position: relative;
  box-shadow: 0 5px 4px rgba(0, 0, 0, 0.3);
`;

const LockCover = styled.div`
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  height: 147px;
  width: 147px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CircularIconHolder = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 100px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  width: 147px;
  height: 147px;
  position: absolute;
  border-radius: 20px;
`;
const Gradient = styled.div`
  width: 147px;
  height: 147px;
  border-radius: 20px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.17) 39.58%,
    #000000 100%
  );
  position: relative;
  z-index: 1;
  display: grid;
  grid-auto-flow: column;
  align-items: flex-end;
`;

const Body = styled.div`
  box-sizing: border-box;
  max-width: 210px;
  padding: 10px;
`;

const CardDetails = styled.div``;

VendorCard.defaultProps = {
  tag: "Loyalty",
  title: "Trivia",
  description:
    "Just keep talking and browsing  to rack up points and you could be the winner! ",
};

export default VendorCard;
